import { Navigate, Outlet, RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@sib/auth';
import { UIContextProvider, Layout } from '@sib/ui';
import {
  SidecarSidebar,
  TopBar,
  WorkInProgressBanner,
  WorkInProgressPopup,
} from '@sidecar/common/components';
import { paths } from '@sidecar/config/paths';
import { routes as auditsRoutes } from './audits';
import { routes as authRoutes } from './auth';
import { routes as dashboardRoutes } from './dashboard';
import { routes as organizationsRoutes } from './organizations';
import { routes as projectRoutes } from './projects';
import { routes as revenueRoutes } from './revenue';
import { routes as storybookRoutes } from './storybook';
import { routes as vendorsRoutes } from './vendors';
import { routes as workRoutes } from './work';

const protectedChildren = [
  ...dashboardRoutes,
  ...workRoutes,
  ...projectRoutes,
  ...organizationsRoutes,
  ...auditsRoutes,
  ...vendorsRoutes,
  ...revenueRoutes,
  ...storybookRoutes,
  {
    path: paths.any,
    element: <Navigate to={paths.dashboard.root} replace />,
  },
] as RouteObject[];

const protectedLayoutRoute = {
  element: (
    <ProtectedRoute fallbackPath={paths.login}>
      <UIContextProvider>
        <Layout sidebar={<SidecarSidebar />} topbar={<TopBar />}>
          <div className="flex h-full min-h-0 flex-col overflow-hidden">
            <WorkInProgressBanner />
            <div className="min-h-0 flex-1 overflow-auto">
              <Outlet />
            </div>
          </div>
        </Layout>
        <WorkInProgressPopup />
      </UIContextProvider>
    </ProtectedRoute>
  ),
  children: protectedChildren,
} as RouteObject;

export const routes: RouteObject[] = [...authRoutes, protectedLayoutRoute];
